import { Component, OnInit, PLATFORM_ID, Inject, ViewChild, ElementRef } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { HttpClient } from '@angular/common/http';
import { Meta, Title } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-enterprise-form-page',
  templateUrl: './enterprise-form-page.component.html',
  styleUrls: ['./enterprise-form-page.component.scss']
})
export class EnterpriseFormPageComponent implements OnInit {

  // trinkaFeatures = [
  //   "Bulk Licenses for Paid plans",
  //   "Institution Plan",
  //   "Sensitive Data Plan",
  //   "API/SDK for Grammar Check",
  //   "API Proofread file",
  //   "Inclusive Language Check",
  //   "Plagiarism Check Reports",
  //   "AI Content Detector",
  //   "Trinka Reports",
  //   "Custom AI Models",
  // ]

  forIntegration = [
    "批量授權",
    "完整性與技術檢測報告",
    "API/SDK 整合",
    "內部部署解決方案",
    "其他/尚不確定，想先透過電話討論"
  ]
  // forBulkLicenses = [
  //   "Bulk Licenses",
  //   "Sensitive Data Plan",
  // ]
  // forReportsOnly = [
  //   "DocuMark",
  //   "Integrity & Technical Checks",
  //   "Plagiarism Check",
  //   "AI Content Detector"
  // ]
  // forOthers = [
  //   "Others"
  // ]
  email: any;
  // emailEnterprise : FormGroup;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  isSubmitting: boolean = false;
  sourceUrl: string | null = null;
  constructor(
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private _document: Document,
    private router: Router,
    public loadScript: LoadScriptService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
  ) {
    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'contactFormSubjects': ['', Validators.required],
      'contactFormMessage': [''],
      'contactphoneNo': ['', Validators.required],
      //'NatureBusinessType': ['', Validators.required],
      'DesignationTypes': ['', Validators.required],
      'countUsers': [''],
      'monthlyCountVolume': [''],
      'integrationFeatures': [[]],
      'website': ['']
      // 'bulkFeatures': [[]],
      // 'reportFeatures': [[]],
      // 'otherFeatures': [[]],
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const encodedSource = params['source'];
      this.sourceUrl = encodedSource ? decodeURIComponent(encodedSource) : null;
      console.log('Captured source URL:', this.sourceUrl);
    });
    this.titleService.setTitle("企業洽詢 | Trinka AI");
    this.metaTagService.updateTag({ name: 'description', content: "與我們的專家洽談，將 Trinka AI 帶入您的企業或機構" });
    this.metaTagService.updateTag({ property: 'og:title', content: "企業洽詢 | Trinka AI" });
    this.metaTagService.updateTag({ property: 'og:description', content: "與我們的專家洽談，將 Trinka AI 帶入您的企業或機構" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/inquiry' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "企業洽詢 | Trinka AI" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "與我們的專家洽談，將 Trinka AI 帶入您的企業或機構" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/inquiry' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/inquiry' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/inquiry' });
  }
  sectionValue(section: string) {
    this.formSection = true;
    this.thankSection = false;
  }

  @ViewChild('thankSectionRef') thankSectionElement!: ElementRef;

  sendContactUsForm() {
    if (this.contactForm.value.website) {
      console.warn('Spam detected');
      return;
    }
    if (this.contactForm.invalid) {
      this.scrollToFirstInvalidControl();
      return;
    }

    if (this.contactForm.valid) {
        this.isSubmitting = true;

        if (!localStorage.getItem("country-trinka")) {
            this.loadGeoAPIScript();
        }

        this.country = localStorage.getItem("country-trinka") || "IN";

        const organizationName = this.contactForm.value.contactFormSubjects || "Unknown Organization";
        const personName = this.contactForm.value.contactFormName;
        const email = this.contactForm.value.contactFormEmail;
        const phone = this.contactForm.value.contactphoneNo;
        const designation = this.contactForm.value.DesignationTypes;
        const countUsers = this.contactForm.value.countUsers || 'N/A';
        const monthlyCountVolume = this.contactForm.value.monthlyCountVolume || 'N/A';
        const integrationFeatures = this.contactForm.value.integrationFeatures || [];
        const source = this.sourceUrl || this.router.url || 'N/A';
        // const bulkFeatures = this.contactForm.value.bulkFeatures || [];
        // const reportFeatures = this.contactForm.value.reportFeatures || [];
        // const miscellanousFeatures = this.contactForm.value.miscellanousFeatures || [];

        const allSelectedFeatures = [
          ...integrationFeatures,
        ];

        const fsString = allSelectedFeatures.length
        ? allSelectedFeatures.join(', ')
        : 'N/A';

        const comments = `Requirement - ${this.contactForm.value.contactFormMessage || ""}
          Inquiry for - ${fsString}
          Approx. Count of Users - ${countUsers}
          Monthly Usage Volume - ${monthlyCountVolume}
          URL - ${source}`;

        console.log("comments are:", comments);

        // const selectedFeatures = this.contactForm.value.tsFeatures;
        // const featuresString = Array.isArray(selectedFeatures) ? selectedFeatures.join(', ') : selectedFeatures;
        const query = `${this.contactForm.value.contactFormSubjects}||${this.contactForm.value.contactFormMessage}||${this.contactForm.value.contactFormName}||${this.contactForm.value.DesignationTypes}||${this.contactForm.value.contactphoneNo}||${fsString}||Approx. Count of Users: ${countUsers}||Approx. Monthly Count of Files/Usage Volume: ${monthlyCountVolume}`;

        this.networkCall.postContactUs(this.contactForm.value.contactFormEmail, query, source).subscribe(result => {

          this.toastr.success("Thanks! We will contact you shortly.")
          this.formSection = false;
          this.thankSection = true;
          this.contactForm.reset();
          this.scrollToThankSection();
        }, error => {
          this.toastr.warning("Something went wrong!")
        }).add(() => {
          this.isSubmitting = false;
        });
    } else {
        this.validateAllFormFields(this.contactForm);
    }
  }

  // createOrganization(organizationName: string, personName: string, email: string, phone: string, commets: string, designation: string) {
  //   const organizationData = { name: organizationName };

  //   this.http.post(`${environment.pipedriveApiUrl}/v1/organizations?api_token=${environment.pipedriveApiToken}`, organizationData)
  //       .subscribe(orgResponse => {
  //           console.log("Organization Created:", orgResponse);
  //           const organizationId = orgResponse['data']?.id;

  //           if (!organizationId) {
  //               console.error("Error: No organization ID returned from Pipedrive.");
  //               return;
  //           }

  //           this.createPersonAndLead(personName, email, phone, organizationId, commets, designation);
  //       }, orgError => {
  //           console.error("Pipedrive Organization Error:", orgError);
  //       });
  // }

  // createPersonAndLead(personName: string, email: string, phone: string, organizationId: number, comments: string, designation: string) {
  //   const personData = {
  //       name: personName,
  //       email: email,
  //       phone: phone,
  //       visible_to: 3,
  //       org_id: organizationId // Associate person with the organization
  //   };

  //   this.http.post(`${environment.pipedriveApiUrl}/v1/persons?api_token=${environment.pipedriveApiToken}`, personData)
  //       .subscribe(personResponse => {
  //           console.log("Person Created:", personResponse);
  //           const personId = personResponse['data']?.id;

  //           if (!personId) {
  //               console.error("Error: No person ID returned from Pipedrive.");
  //               return;
  //           }

  //           this.createLead(personName, personId, organizationId, comments, designation);
  //       }, personError => {
  //           console.error("Pipedrive Person Error:", personError);
  //       });
  // }

  // createLead(personName: string, personId: number, organizationId: number, comments: string, designation: string) {
  //   const pipedriveData = {
  //       title: personName,
  //       owner_id: 21257804,
  //       label_ids: [],
  //       person_id: personId,
  //       organization_id: organizationId,
  //       value: { amount: 0, currency: "INR" },
  //       expected_close_date: null,
  //       visible_to: "3",
  //       was_seen: 1,
  //       origin_id: null,
  //       channel: null,
  //       channel_id: null,
  //       "ab9df2f471b661d064548dc401e65436abe0638b": comments, //comments
  //       "3d44a486ef816801bc5a5ce2afe8ec8066a07324": designation, //designation
  //       "fd8732da92bc0b0ff2858e31a9c7fa17c8606b9d": this.country   ///Capture country
  //   };

  //   this.http.post(`${environment.pipedriveApiUrl}/v1/leads?api_token=${environment.pipedriveApiToken}`, pipedriveData)
  //       .subscribe(leadResponse => {
  //           console.log("Lead Created:", leadResponse);
  //       }, leadError => {
  //           console.error("Pipedrive Lead Error:", leadError);
  //       });
  // }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  isSelected(formControlName: string, feature: string): boolean {
    return this.contactForm.get(formControlName)?.value.includes(feature);
  }
  
  toggleFeature(formControlName: string, feature: string, checked: boolean) {
    const control = this.contactForm.get(formControlName);
    if (!control) return;
  
    let current = control.value || [];
  
    if (checked) {
      if (!current.includes(feature)) {
        current.push(feature);
      }
    } else {
      current = current.filter((f: string) => f !== feature);
    }
  
    control.setValue(current);
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = document.querySelector(
      'form .ng-invalid'
    ) as HTMLElement;
  
    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidControl.focus();
    }
  }

  scrollToThankSection() {
    setTimeout(() => {
      const offset = 100; // Adjust this value based on the desired offset
      const elementPosition = this.thankSectionElement?.nativeElement.getBoundingClientRect().top || 0;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }, 100);
  }

}
